import type { User } from '@highlight/common'

export function getUserFullName(user: Pick<User, 'firstName' | 'lastName'> | null | undefined): string | undefined {
  if (!user) {
    return undefined
  }
  return [user.firstName, user.lastName].filter(Boolean).join(' ') || undefined
}
